export * from './W3MFrameProviderSingleton.js';
//# sourceMappingURL=index.js.map